import React, { useContext, useEffect, useRef, useState } from 'react';
import { systemCode, xs_isMobile, xs_languageCode } from '../..';
import MessageInfo from '../../common/MessageInfo';
import { getLabel } from '../../InitData';
import { UserContext } from '../betslip/UserConf';
import { getConfiguration } from '../utils';
import { getStreamingBalanceLimit } from './streamingUtils';

function GeniusStreamingV3(props) {
	
	/*
	 * TO TEST A SPECIFIC FIXTURE WITHOUT BOOKING IT, IN UAT:
	 * - MAKE THE UAT ENVIROMENT AVAILABLE IN A TEST ENVIROMENT; YOU WILL HAVE AN AUTH TOKEN USED BY THE SYSTEM IN AUTOMATIC WAY
	 *   AND A LIST OF FIXTURES IN THE PUMP LOG
	 *   
	 * - IF YOU DON'T HAVE A TEST ENV, THEN USE THE MAIN METHOD IN CLASS GeniusStreamingApiV3.java,
	 *   USING THE UAT API KEY AND "UAT" AS gev FIELD. YOU WILL GET AN AUTH TOKEN (TO HARDCODE IN THE CONTROLLER)
	 *   AND A LIST OF FIXTURES IN THE ECLIPSE CONSOLE
	 *   
	 *   - REMOVE COMMENTS BRACKETS IN Prematch.js RELATIVES TO "genius" AND PASS THE FIXTURE ID AS PROPS IN THIS COMPONENT
	 *   
	 *   - AN "UGLY" IFRAME WILL BE SHOWN IN THE WEBSITE, AND THE PLAYER INSIDE IT
	 *   
	 *   - AT THE END OF THE TEST, RE-ADD COMMENTS IN Prematch.js COMPONENT, AND REMOVE THE HARDCODED STUFF IN BACKEND, IF ANY
	 * */
	
	const userContext = useContext(UserContext);
	const user = userContext.getUser();
	const balanceLimit =  getStreamingBalanceLimit();
	const isBalanceLimited = balanceLimit >0 && balanceLimit > user.balance;
    const fixtureId = props.fid;
	const customerId = props.confData.gci;
    const playerContainerElement = "container-player";
	const playerScriptElement = "script-player";
	const conf = getConfiguration();
	const streamingDataUrl = conf['api']['getLiveStreamingGeniusData'];
	const isMobile = xs_isMobile;
	const language = xs_languageCode;
	const iframeRef = useRef();
	const urlScript = props.confData.gjs.replace(/{env}/g, props.confData.gev === 'UAT'? 'uat':'production');
	const [geniusError, setGeniusError] = useState(null);
	const loadScript = function (urlScript) {
		var frame = document.querySelector('.genius-iframe-live-streaming');
		if(frame != null){
			var script = document.createElement('script');
			// Width
			const width = iframeRef.current.clientWidth - 30;
			// Height
			const height = iframeRef.current.clientHeight - 30;

			if(frame && frame.contentDocument.getElementById(playerScriptElement)){
				frame.contentDocument.getElementById(playerScriptElement).remove();
			}

			if(frame && frame.contentDocument.getElementById(playerContainerElement)){
				frame.contentDocument.getElementById(playerContainerElement).remove();
			}

			frame.contentWindow.addEventListener('geniussportsmessagebus', function(event){
				if(event.detail.type === 'player_ready'){
		
					const deliveryType = event.detail.body.deliveryType;
				    const streamId = event.detail.body.streamId;
				    const deliveryId = event.detail.body.deliveryId;
				    const fixtureId = event.detail.body.geniusSportsFixtureId;
				    // get streaming stuff with a pure js ajax
				    const request = new XMLHttpRequest();
				    const queryParams = [];
				    queryParams.push("systemCode=" + systemCode);
				    queryParams.push("hash=");
				    queryParams.push("lingua=" + language);
				    queryParams.push("fixtureId=" + fixtureId);
				    queryParams.push("streamId=" + streamId);
				    queryParams.push("deliveryId=" + deliveryId);
				    queryParams.push("deliveryType=" + deliveryType);
				    queryParams.push("isMobile=" + isMobile);
				    request.open('GET',streamingDataUrl + "?" + queryParams.join("&"), true);
					request.timeout = 60000;
					
					request.onreadystatechange = function() {
		
					    if (request.readyState == 4) {
					        if(request.status == 200) {
					            const streamingData = JSON.parse(request.responseText);
					            try {
					            	frame.contentWindow.GeniusLivePlayer.player.start(streamingData);
					            }
					            catch(e){
					            	console.log(e);
					            }
					        }
					    }
					};
					request.send();
				}
				else if(event.detail.type === 'player_not_ready'){
					const errorsArray = event.detail.body?.error;
					let errorString = null;
					if(errorsArray){
						for(let ki in errorsArray){
							const error = errorsArray[ki];
							if(!errorString){
								errorString = '';
							}
							errorString += ("[" + error.code + "] " + error.message + '\n');
						}
					}
					setGeniusError(errorString);
				}
			});
			
			
			const scriptQueryParams = [];
			scriptQueryParams.push("customerId=" + customerId);
			scriptQueryParams.push("fixtureId=" + fixtureId);
			scriptQueryParams.push("containerId=" + playerContainerElement);
			scriptQueryParams.push("controlsEnabled=true");
			scriptQueryParams.push("allowFullScreen=true");
			scriptQueryParams.push("audioEnabled=true");
			scriptQueryParams.push("autoplayEnabled=true");
			scriptQueryParams.push("width=" + width);
			scriptQueryParams.push("height=" + height);
			var container =  document.createElement('div');
			script.id = playerScriptElement;
			script.async = false;
			script.src = urlScript + "?" + scriptQueryParams.join('&');
			container.setAttribute("id",playerContainerElement);
			frame.contentDocument.head.appendChild(script);
			frame.contentDocument.body.appendChild(container)
		}
	};

	useEffect(() => {
        loadScript(urlScript);
    }, [fixtureId]);
    
    return (
		<>
		{user.logged || props.forceLogged?
			(!isBalanceLimited?
				<>
				{
					geniusError?  
					<MessageInfo message={geniusError} /> 
					:
					<iframe ref={iframeRef} title="bet-genius-live-stream" scrolling="yes" className={"genius-iframe-live-streaming"}></iframe>
				}
			 	</>
			 :
			 <MessageInfo message={getLabel('live_page.stream_widget.insufficient_balance')} />
			)
		:
			<MessageInfo message={getLabel('live_page.stream_widget.must_login')} />
		}
		</>
    );

}

export default GeniusStreamingV3;